import {ValueOf} from 'next/constants'

import {insurancePeerBirth} from '$share/constants/insurance'

export function getPeerAge(age: number): ValueOf<typeof insurancePeerBirth> {
    const 나이대 = Math.floor(age / 10) * 10

    if (나이대 >= 60) {
        return `60o`
    }

    return `${나이대}` as ValueOf<typeof insurancePeerBirth>
}
